import React, { useState, useRef, useEffect } from "react";
import "./tooltip.css";

const Tooltip = ({
    children,
    content,
    position = "top",
    className = "",
    disabled = false
}) => {
    const [isVisible, setIsVisible] = useState(false);
    const timeoutRef = useRef(null);

    // Declared before the `disabled` early return so the hook count stays stable
    // when a caller toggles `disabled` between renders.
    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    if (disabled) {
        return children;
    }

    const handleMouseEnter = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setIsVisible(true);
    };

    const handleMouseLeave = () => {
        timeoutRef.current = setTimeout(() => {
            setIsVisible(false);
        }, 100); // Small delay to prevent flashing
    };

    // Generate container class based on position
    const getContainerClass = () => {
        const baseClass = "custom-tooltip-container";
        if (position === "right") {
            return `${baseClass} tooltip-right`;
        } else if (position === "left") {
            return `${baseClass} tooltip-left`;
        } else if (position === "bottom") {
            return `${baseClass} tooltip-bottom`;
        }
        return baseClass;
    };

    return (
        <span className="relative inline-block">
            <span
                className="inline-block"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                {children}
            </span>

            {isVisible && content && (
                <span
                    className={getContainerClass()}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    <span className="custom-tooltip-content">
                        <span
                            className="text-small leading-[125%] font-normal"
                            style={{ color: 'white' }}
                        >
                            {content}
                        </span>
                        <span className="custom-tooltip-arrow" />
                    </span>
                </span>
            )}
        </span>
    );
};

export default Tooltip;
